<section id="content">
    <div class="card">
      <div class="card-title">
        <h2>RFP Summary</h2>
      </div>
      <div class="rfp-summary-container">
        <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
          <p-accordionTab header="RFP Summary Table">
            <div class="group-cont">
              <div class="table-responsive">
                <p-table #dtRfpSummary class="table" styleClass="ui-table-products" tableStyleClass="table table-responsive"
                  [value]="rfpSummary" totalRecords="{{rfpSummary.length}}" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true" [resizableColumns]="true"
                  (onFilter)="onTableFilter($event)"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                  <ng-template pTemplate="caption">
                    <div style="text-align: right">
                      <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                        (click)="exportRfpSummaryExcel()" style="margin-top: 0.5em;margin-right: 0.5em;"
                        class="ui-button-success"></button>
                      <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                        (click)="exportRfpSummaryPdf()" label="PDF" class="ui-button-warning"></button>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th>#</th>
                      <th pSortableColumn="customerName" width="18%">Customer Name
                        <p-sortIcon field="customerName"></p-sortIcon>
                      </th>
                      <th pSortableColumn="deploymentType" width="18%">Deployment Type
                        <p-sortIcon field="deploymentType"></p-sortIcon>
                      </th>
                      <th pSortableColumn="rfpCount" width="15%">RFP Count
                        <p-sortIcon field="rfpCount"></p-sortIcon>
                      </th>
                      <th pSortableColumn="totalProjectDuration" width="20%">Total Project Duration
                        <p-sortIcon field="totalProjectDuration"></p-sortIcon>
                      </th>
                      <th pSortableColumn="averageInitialBidBond" width="18%">Average Initial Bid Bond
                        <p-sortIcon field="averageInitialBidBond"></p-sortIcon>
                      </th>
                      <th pSortableColumn="averageFinalBidBond" width="18%">Average Final Bid Bond
                        <p-sortIcon field="averageFinalBidBond"></p-sortIcon>
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <p-columnFilter field="customerName" type="text" display="menu"
                          placeholder="Customer Name"></p-columnFilter>
                      </th>
                      <th>
                        <p-columnFilter field="deploymentType" type="text" display="menu"
                          placeholder="Deployment Type"></p-columnFilter>
                      </th>
                      <th>
                        <p-columnFilter field="rfpCount" type="numeric" display="menu"
                          placeholder="RFP Count"></p-columnFilter>
                      </th>
                      <th>
                        <p-columnFilter field="totalProjectDuration" type="numeric" display="menu"
                          placeholder="Total Project Duration"></p-columnFilter>
                      </th>
                      <th>
                        <p-columnFilter field="averageInitialBidBond" type="numeric" display="menu"
                          placeholder="Average Initial Bid Bond"></p-columnFilter>
                      </th>
                      <th>
                        <p-columnFilter field="averageFinalBidBond" type="numeric" display="menu"
                          placeholder="Average Final Bid Bond"></p-columnFilter>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-summary let-i="rowIndex">
                    <tr>
                      <td>{{i + 1}}</td>
                      <td>{{summary.customerName}}</td>
                      <td>{{summary.deploymentType}}</td>
                      <td>{{summary.rfpCount}}</td>
                      <td>{{summary.totalProjectDuration}}</td>
                      <td>{{summary.averageInitialBidBond | number:'1.2-2'}}</td>
                      <td>{{summary.averageFinalBidBond | number:'1.2-2'}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
      <div class="card">
        <div class="card-title">
          <h2>RFP Summary Chart</h2>
        </div>
        <div class="cont" id="chart-Container">
          <div class="p-grid"
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <div class="p-col-6" style="flex: 1; padding: 0 5px;">
              <label for="groupBy">Group By:</label>
              <p-dropdown id="groupBy" [options]="rfpSummaryGroupByOptions" [(ngModel)]="selectedRfpSummaryGroupBy"
                (onChange)="onRfpSummaryGroupByChange()" optionLabel="label" optionValue="value">
              </p-dropdown>
            </div>
            <div class="p-col-6" style="flex: 1; padding: 0 5px;">
              <label for="dataType">Data Type:</label>
              <p-dropdown id="dataType" [options]="rfpSummaryDataTypes" [(ngModel)]="selectedRfpSummaryDataType"
                (onChange)="onRfpSummaryDataTypeChange()" optionLabel="label" optionValue="value">
              </p-dropdown>
            </div>
          </div>
          <p-chart #rfpSummaryChart type="bar" [data]="rfpSummaryChartData" [options]="rfpSummaryChartOptions"
            height="380px"></p-chart>
          <button type="button" (click)="exportRfpSummaryChartAsImage()" class="ui-button-success export-button"
            style="margin-top: 1em;">Export Chart as PNG</button>
          <button type="button" (click)="exportRfpSummaryChartAsPDF()" class="ui-button-success export-button"
            style="margin-top: 1em;">Export Chart as PDF</button>
        </div>
      </div>
    </div>
  </section>